import script from "./ConfigPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigPanel.vue?vue&type=script&setup=true&lang=js"

export default script